import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

const mainUrl = '/v2/artist/templates';

function fixParams(params) {
  params = params || {};

  let fields = null;
  if (_.has(params, 'fields')) {
    fields = params.fields;
    delete params.fields;
  }

  params = snakeCaseKeys(params);

  if (fields && _.size(fields)) {
    Object.keys(fields).forEach((key) => {
      params[`fields[${key}]`] = fields[key];
    });
  }

  return params;
}

export const listTemplates = (params) => {
  params = fixParams(params);
  return api.get(mainUrl, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  });
};

export const listPriceTemplates = (params) => {
  // params = params || {};
  params = fixParams(params);
  params.type = 'price';

  return api.get(mainUrl, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  });
};

export const getTemplate = (id, params) => api.get(`${mainUrl}/${id}`, {
  params: {
    ...params,
  },
}).then(({ data: { data } }) => {
  console.log(data);
  return data;
});

export const createTemplate = (data) => api.request('post', mainUrl, {
  data,
});

export const updateTemplate = ({ templateId, data }) => api.request('patch', `${mainUrl}/${templateId}`, {
  data,
});

export const deleteTemplate = (id) => api.request('delete', `${mainUrl}/${id}`, {
  params: {
    ...api.getLocaleParams(),
  },
});

export const listMetadataTemplates = (params) => {
  params = params || {};
  params.type = 'metadata';
  return api.get(mainUrl, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
};

// ======= PRICE TEMPLATE ITEMS ======= //

// eslint-disable-next-line
export const createTemplateItem = (templateId, data) => {
  return api.request('post', `${mainUrl}/${templateId}/items`, {
    data,
  });
};

// eslint-disable-next-line
export const updateTemplateItem = (templateId, itemId, data) => {
  return api.request('patch', `${mainUrl}/${templateId}/items/${itemId}`, {
    data,
  });
};

// eslint-disable-next-line
export const deleteTemplateItem = (templateId, itemId) => {
  return api.request('delete', `${mainUrl}/${templateId}/items/${itemId}`);
};

// ======= END PRICE TEMPLATE ITEMS ======= //
